import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PODetailView, POComment, PURCHASE_ORDER_MOCK } from '../../mock/purchase-order.mock';

@Component({
  selector: 'app-purchase-order-view',
  templateUrl: './purchase-order-view.component.html',
  styleUrls: ['./purchase-order-view.component.scss']
})
export class PurchaseOrderViewComponent implements OnInit {
  po: PODetailView = { ...PURCHASE_ORDER_MOCK, comments: [...PURCHASE_ORDER_MOCK.comments] };
  newComment = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Future: use this.route.snapshot.paramMap.get('id') to fetch from API
  }

  formatCurrency(amount: number, currency: string): string {
    const locale = currency === 'BRL' ? 'pt-BR' : currency === 'MXN' ? 'es-MX' : 'es-CO';
    return new Intl.NumberFormat(locale, {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
  }

  addComment(): void {
    const text = this.newComment.trim();
    if (!text) return;
    const comment: POComment = {
      id: String(Date.now()),
      authorName: 'Kender Correia',
      authorInitials: 'KC',
      date: new Date()
        .toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
        .toUpperCase(),
      text
    };
    this.po.comments = [comment, ...this.po.comments];
    this.newComment = '';
  }

  resubmitForApproval(): void {
    // TODO: wire to MakersFinancesMgrService
    console.log('Resubmit for approval — id:', this.po.id);
  }

  downloadDocument(): void {
    // TODO: wire to MakersFinancesMgrService.previewFile()
    console.log('Download document — key:', this.po.document?.key);
  }

  getInitialsColor(initials: string): string {
    const colors = ['#E65100', '#1565C0', '#2E7D32', '#6A1B9A', '#AD1457', '#00695C'];
    const idx = initials.charCodeAt(0) % colors.length;
    return colors[idx];
  }
}
